/* tslint:disable */

declare var Object: any;
export interface CampaignSettingInterface {
  "name"?: string;
  "campaignId"?: string;
  "destinationTypeId"?: string;
  "description"?: string;
  "active"?: boolean;
  "setCode"?: string;
  "key"?: string;
  "value"?: string;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class CampaignSetting implements CampaignSettingInterface {
  "name": string;
  "campaignId": string;
  "destinationTypeId": string;
  "description": string;
  "active": boolean;
  "setCode": string;
  "key": string;
  "value": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: CampaignSettingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CampaignSetting`.
   */
  public static getModelName() {
    return "CampaignSetting";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CampaignSetting for dynamic purposes.
  **/
  public static factory(data: CampaignSettingInterface): CampaignSetting{
    return new CampaignSetting(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CampaignSetting',
      plural: 'CampaignSettings',
      path: 'CampaignSettings',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "campaignId": {
          name: 'campaignId',
          type: 'string'
        },
        "destinationTypeId": {
          name: 'destinationTypeId',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: false
        },
        "setCode": {
          name: 'setCode',
          type: 'string'
        },
        "key": {
          name: 'key',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
